import { Skeleton } from '@/shared/components/ui/skeleton';

export function FieldLogListPendingState() {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-3 p-4 md:p-6">
      <Skeleton className="h-9 w-48" />
      <Skeleton className="min-h-64 flex-1" />
    </div>
  );
}
